import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=c69f005c&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=c69f005c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69f005c",
  null
  
)

export default component.exports